const url = 'https://us-central1-portal.cloudfunctions.net';

export default { url };